import { SuccessBanner } from "@Light/components/page/SuccessBanner";
import { Clock } from "@untitledui/icons";

export const NoChargeNotice = () => (
  <SuccessBanner icon={Clock}>
    You're not charged until your first bill.
  </SuccessBanner>
);
